import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { DsmNote, DsmNotePayload } from '../models/dsm-notes.models';

@Injectable({ providedIn: 'root' })
export class DsmNotesService {
  readonly #api = inject(ApiCallingV2Service);
  readonly #baseUrl = `${inject(API_CONFIG).baseUrlV2}/dsm/lots`;

  readNotes(lotId: string): Observable<DsmNote[]> {
    return this.#api.getData<DsmNote[]>(`${this.#baseUrl}/${lotId}/notes`, {
      showLoader: false,
      showMessage: false
    });
  }

  createNote(lotId: string, payload: DsmNotePayload): Observable<DsmNote> {
    return this.#api.postData<DsmNote>(
      `${this.#baseUrl}/${lotId}/notes`,
      { showLoader: false, showMessage: true },
      payload
    );
  }

  updateNote(lotId: string, noteId: string, payload: DsmNotePayload): Observable<DsmNote> {
    return this.#api.putData<DsmNote>(`${this.#baseUrl}/${lotId}/notes/${noteId}`, payload, {
      showLoader: false,
      showMessage: true
    });
  }

  deleteNote(lotId: string, noteId: string): Observable<void> {
    return this.#api.deleteData<void>(`${this.#baseUrl}/${lotId}/notes/${noteId}`, {
      showLoader: false,
      showMessage: true
    });
  }
}
